'use client'
import React, { useState } from 'react'

const About = () => {
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <div className="mt-8 mx-4">
      <h1 dir="rtl" className="text-about_headerColor text-lg font-bold text-center underline">
        אודות
      </h1>
      <div
        dir="rtl"
        className={`text-about_textColor text-lg font-medium text-center mx-auto sm:max-w-[700px] ${
          isExpanded ? '' : 'line-clamp-5 overflow-hidden'
        }`}
      >
        <p className="my-2 font-bold">עיצוב מדויק. תכנון חכם. שקט נפשי לאורך כל הדרך</p>
        <p className="my-2">
          נעים להכיר אני דפנה כהן, מעצבת פנים עם ניסיון עשיר בתכנון, ליווי וניהול פרויקטים של שיפוץ ובניה. מרצה לעיצוב,
          עם גישה המשלבת יצירתיות עם חשיבה פרקטית, רגישות למה שחשוב באמת, וראייה רחבה של כל התהליך.
        </p>
        <p className="my-2">
          אם אתם עומדים בפני שיפוץ או בנייה – אתם לא צריכים רק עין טובה. אתם צריכים תכנון נכון, מבט כולל וליווי מקצועי
          שיחסכו לכם זמן, כסף והתלבטויות.
        </p>
        <p className="my-2">
          הסטודיו שלי מלווה אתכם באופן אישי ומדויק – מהשלב הראשון ועד לסיום הפרויקט. בהקשבה אמיתית, הבנה עמוקה של
          הרצונות והעדפות שלכם, וניהול מסודר שמאפשר לכם לעבור את הדרך בביטחון וברוגע.
        </p>
        <p className="my-2 font-bold">מה חשוב לי בתהליך העבודה:</p>
        <ul className="list-disc pr-5 text-right text-base">
          <li>תכנון מדויק שממקסם את המרחב ונותן פתרונות שנשארים נכונים לאורך זמן</li>
          <li>ניהול מקצועי של כל שלבי הביצוע – מול בעלי מקצוע, תקציב ולוחות זמנים</li>
          <li>ליווי אישי עם הקשבה אמיתית, ידע מעשי וניסיון המובילים אתכם בבטחה לאורך כל הדרך</li>
        </ul>
        <p className="my-2 font-bold">כי עיצוב טוב זה לא רק איך שזה נראה</p>
        <p className="my-2">
          העיצוב הסופי הוא רק חלק מהתמונה. עיצוב טוב נבנה לאורך הדרך – בבחירות הנכונות, בסדר, בדיוק, בחיסכון בזמן
          ובתקציב, ובעיקר בתחושת הביטחון שמתלווה לכל שלב.
        </p>
        <p className="my-2">
          תכנון נכון חוסך טעויות
          <br />
          ליווי מקצועי מביא שקט נפשי.
          <br />
          ועם מעצבת מנוסה – תגיעו לתוצאה שלא רק תיראה טוב, אלא גם תרגיש מדויקת ונכונה לכם.
        </p>
      </div>

      <button
        onClick={toggleReadMore}
        className="text-about_callToActionTextColors text-sm font-bold text-center mx-auto mt-2 block underline"
      >
        {isExpanded ? 'קרא פחות' : 'קרא עוד'}
      </button>

      <p dir="rtl" className="text-about_callToActionTextColors text-lg font-bold text-center mx-auto mt-4">
        בואו נתחיל פרויקט חדש ביחד!
      </p>
    </div>
  )
}

export default About
